export default __webpack_public_path__ + "static/media/P500_RoHS.516c4b79.pdf";